import { ReactNode } from 'react';
import { Field } from '@chakra-ui/react';
import WarningTriangleIcon from '../../assets/icons/WarningTriangleIcon';

interface FieldErrorMessageProps {
  showIcon?: boolean;
  children: ReactNode;
}

export default function FieldErrorMessage({ children, showIcon = true }: FieldErrorMessageProps) {
  return (
    <Field.ErrorText justifyContent="space-between">
      {children}
      {showIcon && <WarningTriangleIcon />}
    </Field.ErrorText>
  );
}
